import Constants from "config/Constants";
import useHyroxBannerEligibility from "components/Banners/hooks/useHyroxBannerEligibility";

const VISIBLE_ON_PAGE = [Constants.routes.workouts.route];

function useHyroxOutputTiersBannerEligibility(): boolean {
  return useHyroxBannerEligibility(VISIBLE_ON_PAGE);
}

export default useHyroxOutputTiersBannerEligibility;
